export const DealStatusTypesForFilter = {
  open: "1",
  canceled: "2",
  lost: "3",
  won: "4",
  draft: "5"
};

export const DealStatusTypes = {
  open: 1,
  canceled: 2,
  lost: 3,
  won: 4,
  draft: 5
};
